export default __webpack_public_path__ + "static/media/shopping_cart.9940e34b.svg";